export enum PricingTerm {
  MONTHLY = 'monthly',
  FULL_TERM = 'full_term',
}
